/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react'
import { Button } from 'react-bootstrap'
import ReactSelect from 'react-select'

import Label from 'live/components/forms/ui/label'
import i18n from 'live/services/i18n'

import { httpVerbMockList, statusMockList } from '../../../../../utils/mock'
import { ConfigHeaderFilterContainer, ConfigHeaderFilterDropdown } from './styles'

interface IProps {
    authors: string[]
    filterAuthor: ISelect
    setFilterAuthor: (k: ISelect) => void
    filterStatus: ISelect
    setFilterStatus: (k: ISelect) => void
    filterHttpVerb: ISelect
    setFilterHttpVerb: (k: ISelect) => void
    generateAuditReport: () => void
    isValidToGenerate: boolean
}

export const ConfigHeaderFilter: React.FC<IProps> = ({
    authors,
    filterAuthor,
    setFilterAuthor,
    filterStatus,
    setFilterStatus,
    filterHttpVerb,
    setFilterHttpVerb,
    generateAuditReport,
    isValidToGenerate
}) => {
    const [show, setShow] = React.useState<boolean>(false)
    const dropdownRef = React.useRef<HTMLDivElement>(null)
    // const [status, setStatus] = React.useState<Option<string>>({ label: '', value: '' })
    // const [assignee, setAssignee] = React.useState<Option<string>>({ label: '', value: '' })

    // const handleFilters = (): void => {
    //     setFilterAuthor(assignee)
    //     setFilterStatus(status)
    // }

    // const handleClearFilters = (): void => {
    //     setFilterAuthor('')
    //     setFilterStatus('')
    //     setAssignee('')
    //     setStatus('')
    // }

    React.useEffect(() => {
        function handleMouseDownAction(this: Document, ev: MouseEvent): void {
            if (
                dropdownRef.current &&
                !dropdownRef.current.contains(ev.target as HTMLElement) &&
                !(ev.target as HTMLElement).className.includes('Select-option')
            ) {
                setShow(false)
            }
        }

        document.addEventListener('mousedown', handleMouseDownAction)

        return () => {
            document.removeEventListener('mousedown', handleMouseDownAction)
        }
    }, [])

    const handleResetFilters = (): void => {
        setFilterAuthor({ label: '', value: '' })
        setFilterHttpVerb({ label: '', value: '' })
        setFilterStatus({ label: '', value: '' })
    }

    return (
        <ConfigHeaderFilterContainer ref={dropdownRef}>
            <div
                className="configheaderfilter-clickable"
                id="systemAudit-configHeaderFilter-clickable"
                onClick={() => {
                    setShow(old => !old)
                }}
            >
                <i className="fas fa-filter" />
                <div className="label">{i18n('FILTERS')}</div>
                <i className={`${show ? 'fas fa-caret-up' : 'fas fa-caret-down'}`} />
            </div>

            <ConfigHeaderFilterDropdown style={{ visibility: show ? 'visible' : 'hidden' }}>
                <div>
                    <Label className="control-label">Status</Label>
                    <ReactSelect
                        options={statusMockList.map(st => ({ value: st.name, label: i18n(st.name) }))}
                        searchable={true}
                        clearable={false}
                        onChange={setFilterStatus}
                        id="systemAudit-configHeaderFilter-field-status"
                        value={filterStatus}
                    />
                </div>
                <div>
                    <Label className="control-label">{i18n('Responsible')}</Label>
                    <ReactSelect
                        options={authors?.map(author => ({ value: author, label: author }))}
                        searchable={true}
                        clearable={false}
                        onChange={setFilterAuthor}
                        id="systemAudit-configHeaderFilter-field-author"
                        value={filterAuthor}
                    />
                </div>
                <div>
                    <Label className="control-label">{i18n('Request Method')}</Label>
                    <ReactSelect
                        options={httpVerbMockList.map(st => ({ value: st.name, label: st.name }))}
                        searchable={true}
                        clearable={false}
                        onChange={setFilterHttpVerb}
                        id="systemAudit-configHeaderFilter-field-httpverb"
                        value={filterHttpVerb}
                    />
                </div>
                <div className="menu-item">
                    <Button
                        bsSize="small"
                        bsStyle="primary"
                        onClick={generateAuditReport}
                        disabled={!isValidToGenerate}
                    >
                        {i18n('Apply')}
                    </Button>
                    <Button bsSize="small" bsStyle="link" onClick={handleResetFilters}>
                        {i18n('Restore defaults')}
                    </Button>
                </div>
            </ConfigHeaderFilterDropdown>
        </ConfigHeaderFilterContainer>
    )
}
